export const GET_OPTIONAL_QUESTIONS_REQUESTED = 'GET_OPTIONAL_QUESTIONS_REQUESTED'
export const GET_OPTIONAL_QUESTIONS_SUCCESS = 'GET_OPTIONAL_QUESTIONS_SUCCESS'
export const GET_OPTIONAL_QUESTIONS_FAILED = 'GET_OPTIONAL_QUESTIONS_FAILED'

export const SAVE_OPTIONAL_QUESTIONS = 'SAVE_OPTIONAL_QUESTIONS'
export const CONVERT_SPECIALIZATIONS = 'CONVERT_SPECIALIZATIONS'
export const CONVERT_CUSTOM_QUESTIONS_ANSWERS = 'CONVERT_CUSTOM_QUESTIONS_ANSWERS'

export const HANDLE_CUSTOM_OPTIONAL_QUESTION = 'HANDLE_CUSTOM_OPTIONAL_QUESTION'
